import getCurrentRoute from 'lib/getCurrentRoute'

export default (routes, path) => {
  const currentRoute = getCurrentRoute(routes, path)
  return currentRoute.node || ''
}
